import { TitleButton } from '@/common/buttons/TitleButton';
import { KrCard } from '@/common/card/KrCard';
import { FilterContainer } from '@/common/dashboard/FilterContainer';
import { Form } from '@/common/form/Form';
import { FormFields } from '@/common/form/rendering/FormFields';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ContentBox } from '@/common/layout/ContentBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { far, fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect, useRef, useState } from 'react';
import { McoFinPaidByProgTypePieChart } from './McoFinPaidByProgTypePieChart';
import { McoFinTopCtrtCard } from './McoFinTopCtrtCard';
import { PaidTrendsCard } from './PaidTrendsCard';

export const McoFinDashboard = () => {
  const rsrc = useRsrc();
  const { navState } = useNavState();

  // Filters
  const [fieldDefs, setFieldDefs] = useState();
  const [formValues, setFormValues] = useNavStateSync('formValues');
  const defaultFormValues = useRef();

  const [idToProgType, setIdToProgType] = useState({});

  useEffect(() => {
    rsrc.data('sc', 'MCO_FIN_DASHBOARD_FILTERS_DATA_PLUGIN', {}).then((res) => {
      setFieldDefs([
        { field: 'rbtPeriodId', displayName: 'Rebate Period', type: 'DROPDOWN', values: res.periods },
        { field: 'pbmIds', displayName: 'PBMs', type: 'TREE', treeData: res.pbmTreeData },
        { field: 'ctrtIds', displayName: 'Contracts', type: 'TREE', treeData: res.ctrtTreeData },
        { field: 'brandProdIds', displayName: 'Brands', type: 'TREE', treeData: res.brandProdTreeData },
        { field: 'progTypeIds', displayName: 'Program Types', type: 'TREE', treeData: res.progTypeTreeData },
      ]);

      defaultFormValues.current = {
        rbtPeriodId: res.periods[0]?.value,
        pbmIds: res.pbmIds,
        ctrtIds: res.ctrtIds,
        brandProdIds: res.brandProdIds,
        progTypeIds: res.progTypeIds,
      };

      if (!navState.formValues) {
        setFormValues(defaultFormValues.current);
      }

      setIdToProgType(res.idToProgType);
    });
  }, []);

  const resetFilters = () => {
    setFormValues(defaultFormValues.current);
  };

  if (!fieldDefs) {
    return;
  }

  return (
    <ContentBox>
      {/* Title */}

      <Title
        icon={fas.faTasks}
        title="Managed Care Financial Dashboard"
        buttons={
          <TitleButton
            key="resetViewButton"
            dataTestId="reset-view-button"
            icon={far.faWindowRestore}
            toolTip="Reset Filters"
            onClick={resetFilters}
          />
        }
      />

      {/* Filters */}
      <Form formValues={formValues} setFormValues={setFormValues}>
        <FormFields fieldDefs={fieldDefs} container={FilterContainer} />
      </Form>

      {/* Main Contents */}
      <SpacerLayout>
        <Spacer weights={[2, 1]}>
          <Spacer vertical>
            <Spacer weights={[3, 5, 5]}>
              {/* <AnomalyDetectionCard setFormValues={setFormValues} defaultFormValues={defaultFormValues.current} /> */}
              <PaidTrendsCard formValues={formValues} idToProgType={idToProgType} />
              {/* <DispTrendsCard formValues={formValues} idToProgType={idToProgType} /> */}
            </Spacer>

            <Spacer weights={[5, 3, 5]}>
              <McoFinTopCtrtCard formValues={formValues} idToProgType={idToProgType} />

              {/* <DashboardCard title="Dispute Code Breakdown" >
                <McoDispBreakdownPieChart formValues={formValues} />
              </DashboardCard>

              <DashboardCard title="Dispute Code Trends" >
                <McoDispTrendChart formValues={formValues} />
              </DashboardCard> */}
            </Spacer>
          </Spacer>
          <KrCard title="Paid by Program Type">
            <McoFinPaidByProgTypePieChart formValues={formValues} idToProgType={idToProgType} />
          </KrCard>
        </Spacer>
      </SpacerLayout>
    </ContentBox>
  );
};
